import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/tailwind.css'
// import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/accessibility.css'
createApp(App).use(router).mount('#app')
